import type { IAppPreferences } from '@erp/native/interfaces';

const PREFIX = 'erp.pref.';

export function createWebPreferences(): IAppPreferences {
  return {
    async get(key) {
      const raw = window.localStorage.getItem(PREFIX + key);
      if (raw == null) return null;
      try {
        return JSON.parse(raw);
      } catch {
        return null;
      }
    },
    async set(key, value) {
      window.localStorage.setItem(PREFIX + key, JSON.stringify(value));
    },
    async remove(key) {
      window.localStorage.removeItem(PREFIX + key);
    },
    async keys() {
      const out: string[] = [];
      for (let i = 0; i < window.localStorage.length; i++) {
        const k = window.localStorage.key(i);
        if (k && k.startsWith(PREFIX)) out.push(k.slice(PREFIX.length));
      }
      return out;
    },
  };
}
